<div class="category">
  <mat-icon *ngFor="let fullStar of fullStars">star</mat-icon>
  <mat-icon *ngFor="let emptyStar of emptyStars">star_border</mat-icon>
</div>